document.body.addEventListener('change', function (event) {
    if (event.target.closest('.form-control-btn')) {
        var btn = event.target.closest('.form-control-btn');
        var input = btn.querySelector('input');
        var form = btn.closest('form');

        form.querySelectorAll('input[name="'+input.getAttribute('name')+'"]').forEach(function(input){
            var btn = input.closest('.form-control-btn');

            if (input.checked) {
                btn.classList.add('active')
            } else {
                btn.classList.remove('active')
            }
        });
    }

    if (event.target.closest('form')) {
        var form = event.target.closest('form');
        form.querySelectorAll('.show-on-changed').forEach(function(el){
            el.classList.remove('invisible');
        })
    }

    if (event.target.closest('[data-toggle-group-radio]')) {
        var switcher = event.target.closest('[data-toggle-group-radio]');
        var radio = switcher.closest('.list-group-item').querySelector('input[type=radio]');
        if (!switcher.checked) {
            radio.checked = false;
            radio.disabled = true;
        } else {
            radio.disabled = false;
        }
    }
});

(function(){
    var observe;
    if (window.attachEvent) {
        observe = function (element, event, handler) {
            element.attachEvent('on'+event, handler);
        };
    }
    else {
        observe = function (element, event, handler) {
            element.addEventListener(event, handler, false);
        };
    }
    function init () {
        var textareas = document.querySelectorAll('textarea');
        textareas.forEach(function(text){
            function resize () {
                text.style.height = 'auto';
                text.style.height = text.scrollHeight+'px';
            }
            /* 0-timeout to get the already changed text */
            function delayedResize () {
                window.setTimeout(resize, 0);
            }
            observe(text, 'change',  resize);
            observe(text, 'cut',     delayedResize);
            observe(text, 'paste',   delayedResize);
            observe(text, 'drop',    delayedResize);
            observe(text, 'keydown', delayedResize);

            resize();
        })
    }
    init();
})();